module.exports = __webpack_public_path__ + "officialStatic/img/n10.7309685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n10.jpg
// module id = igNT
// module chunks = 0